<template>
    <div class="box">
        <div class="box-offset">
            <div class="box-ttl-wrap">
                <div class="box-ttl">History</div>
                <div class="buttons--row mb-4 mt-4">
                    <div class="search--block">
                        <button
                            class="search--block-btn"
                            type="submit"
                            @click="getApplicantHistory"
                        >
                            <img src="/img/svg/icons-search.svg" alt="search">
                        </button>
                        <input
                            type="search"
                            class="search--block-txt"
                            placeholder="Search by Name"
                            v-model="filters.search"
                            @input="handleSearch"
                        />
                    </div>
                </div>
            </div>
            <div class="table-holder table-responsive">
                <table class="table">
                    <thead>
                    <tr>
                        <th class="col-min-width">Stage</th>
                        <th>
                            <nobr>
                                User
                            </nobr>
                        </th>
                        <th>
                            <nobr>Date</nobr>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="record in historyRecords"
                        :key="record.id"
                    >
                        <td>
                            <b>{{record.status_item.template.name}} - {{record.action}}</b>
                        </td>
                        <td>
                            {{record.user.name}} {{record.user.last_name}}
                        </td>
                        <td>
                            <div class="text-14 color--text-gray">
                                {{ formatDate(record.date)}}
                            </div>
                        </td>

                    </tr>
                    </tbody>
                </table>
            </div>
            <Pagination
                class="ml-1 mr-1"
                :currentPage="pagination.current_page"
                :lastPage="pagination.last_page"
                @changeItemsPerPage="changeItemsPerPage"
                @changePage="changePage"/>
        </div>
    </div>

</template>

<script>
import ApplicantsServices from "../services/ApplicantsServices";
import DateConverter from "../../../../../../resources/js/mixins/DateConverter";
import PaginationHandler from "../../../../../../resources/js/mixins/PaginationHandler";
import _ from "lodash";

export default {
    name: 'History',
    props: {
        userId: {
            type: Number
        }
    },
    mixins: [DateConverter, PaginationHandler],
    data() {
        return {
            historyRecords: [],
            filters: {
                search: '',
                page: 1,
                perPage: 10
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },
    methods: {
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },
        delayedSearch: _.debounce(function() {
            this.getApplicantHistory(this.filters)
        }, 500),
        getList(filters) {
            this.getApplicantHistory(filters)
        },
        async getApplicantHistory () {
            try {
                const { data: response } = await ApplicantsServices.getApplicantStatusHistory(this.userId, this.filters)
                this.historyRecords = response.data
                this.pagination.current_page = response.current_page
                this.pagination.last_page = response.last_page

            } catch (e) {
                console.error(e)
                this.$showErrorMessage('History was not uploaded')
            }
        }
    },
    mounted() {
        this.getApplicantHistory();
    }
}

</script>

<style scoped>

</style>
